import { useState, useEffect } from 'react';
import { AlertTriangle, X, Phone } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const DISMISS_KEY = 'phone-banner-dismissed-at';
const DISMISS_TTL_MS = 24 * 60 * 60 * 1000; // 24h — resurfaces daily until phone is set

export const PhoneOnboardingBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(true); // start hidden until we know

  useEffect(() => {
    const at = Number(localStorage.getItem(DISMISS_KEY) || 0);
    setDismissed(at && Date.now() - at < DISMISS_TTL_MS);
  }, []);

  const hasPhone = !!(user?.phone && user.phone.trim());
  if (hasPhone || dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setDismissed(true);
  };

  const handleSetPhone = () => {
    window.dispatchEvent(new CustomEvent('open-profile-editor'));
  };

  return (
    <div
      className="bg-amber-50 border-b border-amber-200"
      data-testid="phone-onboarding-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-start sm:items-center gap-3 flex-col sm:flex-row">
        <div className="flex items-start sm:items-center gap-3 flex-1">
          <div className="w-8 h-8 flex-shrink-0 bg-amber-100 border border-amber-300 flex items-center justify-center">
            <AlertTriangle className="w-4 h-4 text-amber-700" />
          </div>
          <div className="text-sm text-amber-900">
            <strong className="font-black">Add your US phone number.</strong>{' '}
            Loads you post right now display the company hotline{' '}
            <code className="bg-amber-100 px-1 py-0.5 text-[12px]">1 (877) 680-9272</code>{' '}
            instead of your direct line — carriers may reach the wrong person.
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0 ml-11 sm:ml-0">
          <button
            onClick={handleSetPhone}
            className="flex items-center gap-1.5 bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 text-xs font-black uppercase tracking-wider transition-colors"
            data-testid="phone-banner-cta"
          >
            <Phone className="w-3.5 h-3.5" />
            Set My Phone
          </button>
          <button
            onClick={handleDismiss}
            className="text-amber-700 hover:text-amber-900 p-2"
            aria-label="Dismiss for today"
            data-testid="phone-banner-dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
